// extracted by mini-css-extract-plugin
export default {"button-common-styles":"CustomButton_button-common-styles__JmYHC","button-text":"CustomButton_button-text__UpYfD"};